import { c as _c } from "react/compiler-runtime";
import Slider, { type SliderProps } from 'rc-slider';
import styles from './input-range-slider.module.scss';
interface InputSliderProps extends Omit<SliderProps, 'onChange' | 'value'> {
  onChange: (value: number) => void;
  value: number;
}
export default function InputSlider(props) {
  const $ = _c(8);
  const {
    max,
    min,
    onChange,
    step,
    value
  } = props;
  let t0;
  if ($[0] !== onChange) {
    t0 = sliderValue => {
      if (!Array.isArray(sliderValue)) {
        onChange(sliderValue);
      }
    };
    $[0] = onChange;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const handleChange = t0;
  let t1;
  if ($[2] !== handleChange || $[3] !== max || $[4] !== min || $[5] !== step || $[6] !== value) {
    t1 = <div className={styles.slider}><div className={styles.slider_input}><Slider step={step} value={value} allowCross={false} min={min} max={max} onChange={handleChange} /></div></div>;
    $[2] = handleChange;
    $[3] = max;
    $[4] = min;
    $[5] = step;
    $[6] = value;
    $[7] = t1;
  } else {
    t1 = $[7];
  }
  return t1;
}